module.exports = __webpack_public_path__ + "static/media/imaging-badge.2c0c57e7.svg";